
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyUs from './components/WhyUs';
import Categories from './components/Categories';
import FeaturedProducts from './components/FeaturedProducts';
import Statistics from './components/Statistics';
import Gallery from './components/Gallery';
import MyStory from './components/MyStory';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <WhyUs />
      <Categories />
      <FeaturedProducts />
      <MyStory />
      <Statistics />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}
